import type { TField, TType } from '@timeedit/types';
import {
  EActivityDraftGroupConfigFieldOptions,
  type TActivityDraftGroupConfigFieldOptionsValuesSchema,
} from '@timeedit/types/lib/types/activityGroup.type';
import intl from '../../../i18n/intl';

const language = intl.messages;

export const fieldOrNamingValueToString = (
  value: TActivityDraftGroupConfigFieldOptionsValuesSchema | undefined,
  fields: TField[],
  objectTypes: TType[]
): string => {
  if (!value) return '';
  const { type } = value;

  switch (type) {
    case EActivityDraftGroupConfigFieldOptions.ACTIVITY_FIELD_VALUE: {
      const field = fields.find((f) => f.extId === value.value);
      return field ? field.name : value.value;
    }

    case EActivityDraftGroupConfigFieldOptions.OBJECT_FIELD_VALUE: {
      const type = objectTypes.find((obj) => obj.id === value.objectTypeIntId);
      const field = fields.find((obj) => obj.id === value.fieldIntId);
      if (field && type) {
        return `${type.name} - ${field.name}`;
      }

      return value.fieldIntId?.toString() ?? '';
    }

    case EActivityDraftGroupConfigFieldOptions.STATIC_TEXT: {
      return value.value;
    }

    case EActivityDraftGroupConfigFieldOptions.NUMBERING: {
      return value.value;
    }

    case EActivityDraftGroupConfigFieldOptions.ACTIVITY_PROPERTY: {
      return (
        language[
          `activity_group_act_prop_${value.value.toLowerCase()}`
        ].toString() ?? value.value
      );
    }

    // Make sure that all cases are handled, otherwise we will get a typing error here
    default: {
      const exhaustiveCheck: never = type;
      throw new Error(
        `Unhandled case: ${JSON.stringify(exhaustiveCheck, null, 2)}`
      );
    }
  }
};
